(() => {
  if (window.t2mSIMRenewalLoaded) return;
  window.t2mSIMRenewalLoaded = true;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const panel = form.querySelector('[data-t2m-sim-renewal]');
    if (!panel) return;
    const input = panel.querySelector('[data-sim-identifiers]');
    const ids = input.value.split(/\n+/).map(value => value.trim()).filter(Boolean);
    const quantity = Number(new FormData(form).get('quantity') || 1);
    const error = panel.querySelector('[data-sim-error]');
    const valid = ids.length === quantity && new Set(ids.map(id => id.toLowerCase())).size === ids.length;
    error.hidden = valid;
    if (!valid) {
      error.textContent = 'Enter one unique SIM or radio ID on each line, matching the quantity (' + quantity + ').';
      event.preventDefault();
      event.stopImmediatePropagation();
      input.focus();
    }
  }, true);
})();